import { Typography } from "@material-ui/core";
import React from "react";

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      Copyright © Timeline 2021
    </Typography>
  );
};

export default Copyright;
